export const ThemeActionType = {
    EMPTY: 0,
    NEW: 1,
    VIEW: 2,
}


// WEBPACK FOOTER //
// ./src/app/shared/constants/question.constants.ts